const RICH_PATH_PREFIXES = [
  '/dashboard',
  '/admin/insights/',
  '/insights/'
]

const LIST_PATH_PATTERNS = [
  /\/list(?:\/|$)/,
  /\/submission_approval(?:\/|$)/,
  /\/admin\/total(?:\/|$)/,
  /\/admin\/sales(?:\/|$)/
]

const FORM_PATH_PATTERNS = [
  /\/(?:register|edit|update)(?:\/|$)/,
  /\/report(?:\/|$)/,
  /\/payoff(?:\/|$)/,
  /\/setting(?:\/|$)/,
  /\/admin\/project-rate(?:\/|$)/
]

const DETAIL_PATH_PATTERNS = [
  /\/(?:info|detail)(?:\/|$)/
]

const FORM_NAME_PATTERN = /(登録|作成|更新|修正|編集|勤務表|業務報告|精算|設定)$/
const DETAIL_NAME_PATTERN = /(詳細|情報)$/
const LIST_NAME_PATTERN = /(一覧|集計|承認待ち|申請一覧|管理)$/
const TRAILING_CONTEXT_PATTERN = /\s*[（(][^（）()]+[）)]\s*$/

function matchesAny (value, patterns) {
  return patterns.some(pattern => pattern.test(value))
}

/**
 * 画面名の末尾に付く利用者区分を、見た目の分類から切り離す。
 *
 * 例:
 * - 休暇申請詳細(管理者) -> 休暇申請詳細
 * - 予定超過残業の申請詳細（管理者） -> 予定超過残業の申請詳細
 *
 * 表示対象や権限はrouter側のまま維持し、detail / form / listの
 * 見た目だけを同じ業務画面種別へ揃える。
 */
export function normalizeRoutePresentationName (value) {
  let normalized = String(value || '').trim()

  while (TRAILING_CONTEXT_PATTERN.test(normalized)) {
    normalized = normalized.replace(TRAILING_CONTEXT_PATTERN, '').trim()
  }

  return normalized
}

export function resolveRoutePresentation (route) {
  const currentRoute = route || {}
  const path = String(currentRoute.path || '')
  const name = normalizeRoutePresentationName(currentRoute.name)

  if (RICH_PATH_PREFIXES.some(prefix => path === prefix || path.startsWith(prefix))) {
    return 'rich'
  }

  /*
   * 古いルーターには /client/list/clientregister のように一覧パスの下へ
   * 登録・詳細をネストした画面がある。最終画面のnameを先に見ることで、
   * 見た目だけが一覧扱いになることを防ぐ。
   *
   * /users/list のような一覧を詳細扱いしないため、IDらしきパスだけで
   * 推測せず、詳細画面はroute nameまたはinfo/detailセグメントで判定する。
   */
  if (FORM_NAME_PATTERN.test(name)) return 'form'
  if (DETAIL_NAME_PATTERN.test(name)) return 'detail'

  if (matchesAny(path, FORM_PATH_PATTERNS)) return 'form'
  if (matchesAny(path, DETAIL_PATH_PATTERNS)) return 'detail'

  if (
    matchesAny(path, LIST_PATH_PATTERNS) ||
    LIST_NAME_PATTERN.test(name)
  ) {
    return 'list'
  }

  return 'standard'
}

export function routePresentationClasses (route) {
  const kind = resolveRoutePresentation(route)

  return [
    'preika-route-view',
    `preika-route-view--${kind}`,
    {
      'preika-route-view--business': kind !== 'rich'
    }
  ]
}
